import config from 'temp/config';

const endpoint = '/api/sitecore/formlogging';

// Sitecore's JSS formbuilder endpoint answers a failed submit with
// { errors: [...], validationErrors: { fieldKey: [...] } } — keep that in the
// log, since it says which server-side check rejected the request.
export function describeSitecoreSubmitErrors(result) {
  const errors = JSON.stringify(result?.errors ?? null);
  const validationErrors = JSON.stringify(result?.validationErrors ?? null);
  return `. Errors: ${errors}. Validation Errors: ${validationErrors}`;
}

export function saveMessageLogs(logList, formData) {
  const fetchData = {
    messages: logList,
    formData: formData,
  };
  console.log('-----saveMessageLogs------', fetchData);
  if (!logList || logList.length < 1) return false;
  const baseUrl = config.sitecoreApiHost + `${endpoint}/Update`;

  return fetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(fetchData),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json());
}
